import { closeModal, openModal } from "../scripts/modals";

export function openModalLoader(textContent) {
    const textDownloadingPdf = parent.document.querySelector("#loader_modal .modal_body_text p");
    textDownloadingPdf.innerHTML = textContent;
    openModal("loader_modal");
}

export function closeModalLoader() {
    const timeout = 1000;
    setTimeout(() => {
        closeModal("loader_modal");
    }, timeout);
}

function startDownloadingAnimation() {}
function stopDownloadingAnimation(timeout = 1000) {}
